const handler = ( $ ) => {
	const $forms = $( '.mailchimp-form' );
	const $pageDesc = $( '.page-contact__desc' );

	if ( $forms.length == 0 ) {
		return;
	}

	const formsEachHandler = ( _, form ) => {
		const $form = $( form ),
			$formField = $( '.mailchimp-form__field', $form ),
			$formSubmit = $( '[type="submit"]', $form ),
			$formInput = $( 'input', $formField ),
			$formResponseOutput = $( '.wpcf7-response-output', $form );

		if ( $form.parents( '.subscribtion' ).length != 0 ) {
			$( 'button[type="submit"]', $form ).text( 'Subscribe' );
		}

		const onInputHandler = ( e ) => {
			const $_input = $( e.target ),
				$parentControlWrap = $_input.parents( '.is-invalid-field' ),
				$inputErrorText = $_input.next( '.wpcf7-not-valid-tip' );

			if ( $parentControlWrap.length != 0 ) {
				$parentControlWrap.removeClass( 'is-invalid-field' );
			}

			if ( $inputErrorText.length != 0 ) {
				$inputErrorText.hide();
			}

			$formResponseOutput.html( '' );
		};

		const formInvalidHandler = ( e ) => {
			$formResponseOutput.html( '' );
		};

		const formSentHandler = () => {
			$pageDesc.hide();
			$formField.hide();
			$formSubmit.hide();
			$formResponseOutput.html( '' );
		};

		$formInput.on( 'input', onInputHandler );
		$form.on( 'wpcf7invalid', formInvalidHandler );
		$form.on( 'wpcf7mailsent', formSentHandler );
	};

	$forms.each( formsEachHandler );
};

( ( $ ) => {
	$( handler );
} )( jQuery );
